import { render } from "./HeaderSearch.ce.vue?vue&type=template&id=c780da38"
import script from "./HeaderSearch.ce.vue?vue&type=script&lang=js"
export * from "./HeaderSearch.ce.vue?vue&type=script&lang=js"

import _style_0 from "./HeaderSearch.ce.vue?vue&type=style&index=0&id=c780da38&inline&lang=scss"

import exportComponent from "/builds/govbr-ds/wbc/govbr-ds-wbc/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['styles',[_style_0]]])

export default __exports__